import { writable } from 'svelte/store';
import rooms from '../rooms';
import cookie from '../helpers/cookie';

const { subscribe, set, update } = writable({});

const ui = createUI({
  zoomLevel: 0, // -1, 0, or 1
  toolbarIsHovered: false,
  pendingJoinOrLeave: false,
  chatterNoise: null,
  feedbackMessage: '',
  resetTokenPosition: [],
  newTokenPosition: {},
  triggerTokenDisplayVideo: false,
  roomName: "public",
  theme: null,
  defaultTheme: rooms['public'].theme,
});

function createUI(init) {
  set(init);

  return {
    set,
    subscribe,
    setTheme,
    startChatter,
    toggleChatter,
  };
}

async function setTheme(roomName) {
  const theme = rooms[roomName] && rooms[roomName].theme;
  // console.log('theme:', theme);
  if (!theme) return false;
  update((ui) => {
    return { ...ui, roomName: roomName, theme: theme };
  });
  return true;
}

function startChatter() {
  const isActive = cookie.get('chatterIsActive');
  update((ui) => {
    if (ui.theme.chatterNoise.audioFile && ui.theme.chatterNoise.volume) {
      ui.chatterNoise = new Audio(ui.theme.chatterNoise.audioFile);
      ui.chatterNoise.volume = isActive === 'false' ? 0 : ui.theme.chatterNoise.volume / 100;
      ui.chatterNoise.loop = true;
    }
    ui.chatterNoise && ui.chatterNoise.play();
    return ui;
  });
}

function toggleChatter() {
  update((ui) => {
    ui.chatterNoise.volume = ui.chatterNoise.volume == 0 ? ui.theme.chatterNoise.volume / 100 : 0;
    cookie.set('chatterIsActive', Boolean(ui.chatterNoise.volume));
    return ui;
  });
}

export { ui };
